import { Flex, Switch, Text } from '@billy/design-system'
import type { ChangeEvent, ReactElement } from 'react'

import { useComponentId } from '../../../../../../hooks'

interface DocumentTypeSettingsSwitchRowProps {
  checked: boolean
  disabled?: boolean
  label: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const DocumentTypeSettingsSwitchRow = ({
  checked,
  disabled,
  label,
  onChange,
}: DocumentTypeSettingsSwitchRowProps): ReactElement => {
  const labelId = useComponentId('document-type-settings-switch-row-label')

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Text id={labelId}>{label}</Text>
      <Switch aria-labelledby={labelId} checked={checked} disabled={disabled} onChange={onChange} />
    </Flex>
  )
}
